import { create } from "zustand";
import { AssociatedPartyAPI } from "../api";
import { AssociatedPartiesHistoryItem } from "../api/transformers/associatedParty";

type AssociatedPartyHistoryStore = {
  data: AssociatedPartiesHistoryItem[];
  loading: boolean;
  error: unknown;
  fetchData: (personId: string) => Promise<void>;
};

const useAssociatedPartyHistoryStore = create<AssociatedPartyHistoryStore>(
  (set) => ({
    data: [],
    loading: true,
    error: null,
    // actions
    fetchData: async (personId) => {
      set({ loading: true, error: null, data: [] });
      try {
        const result = await AssociatedPartyAPI.getAssociatedPartyHistory(
          personId
        );
        set({ data: result, loading: false });
      } catch (err) {
        console.error(err);
        set({ error: err, loading: false });
      }
    },
  })
);

export default useAssociatedPartyHistoryStore;
